module.exports = __webpack_public_path__ + "img/dietary.89fda92f.svg";